module.exports = __webpack_public_path__ + "img/v.a61ca4d3.jpg";